import React, { useEffect, useState } from "react";
import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import star from "../assets/img/icons8-3-stars.gif";

gsap.registerPlugin(ScrollTrigger);

const Footer = () => {
  useEffect(() => {
    // Animated Text
    const ft = gsap.timeline({
      scrollTrigger: {
        trigger: ".footerLogo",
        start: "bottom bottom",
        end: "bottom bottom",
        scrub: 4,
        // markers: true,
      },
    });
    ft.to(".foot_txt", {
      y: 0,
      stagger: {
        amount: 0.8,
      },
      ease: "bounce.in",
    });
  }, []);

  const [showEndPopup, setShowEndPopup] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const footer = document.querySelector(".lastpopup");
      if (footer) {
        const footerPosition = footer.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;

        if (footerPosition < windowHeight) {
          setShowEndPopup(true);
          // You can also perform any action you want when the footer is visible
        } else {
          setShowEndPopup(false);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const closePopup = () => {
    setShowEndPopup(false);
  };

  return (
    <>
      <div className="lastpopup"></div>
      {showEndPopup && (
        <div className="popup custom-css">
          <div className="last_section_footer">
            <div className="popup-close" onClick={closePopup}>
              <i className="fa fa-close" />
            </div>
            <h6>
              Like what you see? <img src={star} alt="" />
            </h6>
            <h6>
              Let's craft your dream brand! <br /> Avail our Exclusive Deals!
            </h6>
            <div className="last_footer_btn">
              <a href="https://wa.me/447577842671">
                <button>Grab your spot now!</button>
              </a>
            </div>
          </div>
        </div>
      )}

      <footer className="footerBottom">
        <div className="container">
          <h2 className="footerLogo">
            <span className="foot_txt hero_txt11">C</span>
            <span className="foot_txt hero_txt11">r</span>
            <span className="foot_txt hero_txt11">i</span>
            <span className="foot_txt hero_txt11">s</span>
            <span className="foot_txt hero_txt11">p</span>
            <span className="foot_txt">B</span>
            <span className="foot_txt">r</span>
            <span className="foot_txt">a</span>
            <span className="foot_txt">i</span>
            <span className="foot_txt">n</span>
            <span className="foot_txt">s</span>
            <span className="foot_txt add_space hero_txt11">L</span>
            <span className="foot_txt hero_txt11">t</span>
            <span className="foot_txt hero_txt11">d.</span>
          </h2>
        </div>
      </footer>
    </>
  );
};

export default Footer;
